import { z } from 'zod';
import { LyDoTangGiamCCDCInput } from '@/types/schemas/ly-do-tang-giam-ccdc.type';

export const toolEquipmentChangeReasonSchema = z.object({
  loai_tg_cc: z.string().min(1, { message: 'Loại tăng giảm là bắt buộc' }),
  ma_tg_cc: z.string().min(1, { message: 'Mã tăng giảm là bắt buộc' }),
  ten_tg_cc: z.string().min(1, { message: 'Tên tăng giảm là bắt buộc' }),
  ten_tg_cc2: z.string().optional().nullable(),
  status: z.string().min(1, { message: 'Trạng thái là bắt buộc' }),
  action: z.string().optional(),
  param: z.string().optional()
});

export type ToolEquipmentChangeReasonFormValues = LyDoTangGiamCCDCInput;

export const initialValues: ToolEquipmentChangeReasonFormValues = {
  loai_tg_cc: '1', // Default to '1. Tăng công cụ'
  ma_tg_cc: '',
  ten_tg_cc: '',
  ten_tg_cc2: '',
  status: '1', // Default to '1. Còn sử dụng'
  action: 'CUSTOM',
  param: 'MANUAL'
};
